import { TIPO_PERIODO_OPTIONS } from './workflow-periodicidad';

export const PERIODO_INSTANCIA_ESTADO_OPTIONS = [
  { value: 'PENDIENTE', label: 'Pendiente' },
  { value: 'NUEVO', label: 'Nuevo' },
  { value: 'GENERADO', label: 'Generado' },
  { value: 'ARCHIVADO', label: 'Archivado' },
];

const TIPO_FILTER_OPTIONS = TIPO_PERIODO_OPTIONS.filter(o => o.value !== 'OTRO');

export const PERIODO_INSTANCIA_TABLE_FILTERS = [
  { label: 'ID', name: 'id' },
  {
    label: 'Estado',
    name: 'estado',
    type: 'select' as const,
    single: true,
    options: PERIODO_INSTANCIA_ESTADO_OPTIONS,
  },
  {
    label: 'Tipo catálogo',
    name: 'tipoPeriodo',
    type: 'select' as const,
    single: true,
    options: TIPO_FILTER_OPTIONS,
  },
  {
    label: 'Tipo periodo',
    name: 'tipo',
    type: 'select' as const,
    single: true,
    options: TIPO_FILTER_OPTIONS,
  },
  { label: 'Periodo ID', name: 'periodoId' },
  { label: 'Año', name: 'anio' },
  { label: 'Número', name: 'numero' },
];

export interface InstanciaFilterParam {
  filterName: string;
  filterValue: string;
}

export function filtersFromSearch(
  search: string,
  filterDefs: typeof PERIODO_INSTANCIA_TABLE_FILTERS = PERIODO_INSTANCIA_TABLE_FILTERS,
): InstanciaFilterParam[] {
  const urlParams = new URLSearchParams(search);
  return filterDefs.flatMap(f => {
    const values = urlParams.getAll(f.name).filter(v => v !== '');
    if ('single' in f && f.single) {
      const v = values.length > 0 ? values[values.length - 1] : null;
      return v != null ? [{ filterName: f.name, filterValue: v }] : [];
    }
    return values.map(v => ({ filterName: f.name, filterValue: v }));
  });
}

/** Params para GET .../tipo/resumen — excluye tipoPeriodo (agrupa por catálogo). */
export function buildInstanciaTipoResumenParams(search: string): URLSearchParams {
  const params = new URLSearchParams();
  filtersFromSearch(search)
    .filter(f => f.filterName !== 'tipoPeriodo')
    .forEach(f => params.append(f.filterName, f.filterValue));
  return params;
}

export function setTipoPeriodoFilter(
  searchParams: URLSearchParams,
  tipoPeriodo: string,
): URLSearchParams {
  const params = new URLSearchParams(searchParams);
  params.delete('tipoPeriodo');
  params.set('tipoPeriodo', String(tipoPeriodo).toUpperCase());
  params.set('page', '1');
  return params;
}

/** Filtros de estado en procesos (mismos valores que acepta el API). */
export type InstanciaEstadoVista = 'PENDIENTE' | 'GENERADO' | 'ARCHIVADO';

export const INSTANCIA_ESTADO_VISTA_RESUMEN: InstanciaEstadoVista[] = [
  'PENDIENTE',
  'GENERADO',
  'ARCHIVADO',
];

export const INSTANCIA_ESTADO_VISTA_LABEL: Record<InstanciaEstadoVista, string> = {
  PENDIENTE: 'Pendiente',
  GENERADO: 'Generado',
  ARCHIVADO: 'Archivado',
};

export function parseInstanciaEstadoVista(estado: string | null): InstanciaEstadoVista {
  const up = estado?.toUpperCase();
  if (up === 'ARCHIVADO') return 'ARCHIVADO';
  if (up === 'PENDIENTE') return 'PENDIENTE';
  return 'GENERADO';
}

/** Params para conteo por estado — excluye `estado` para mostrar el desglose completo. */
export function buildInstanciaEstadoResumenParams(search: string): URLSearchParams {
  const params = new URLSearchParams();
  filtersFromSearch(search)
    .filter(f => f.filterName !== 'estado')
    .forEach(f => params.append(f.filterName, f.filterValue));
  return params;
}

export function setInstanciaEstadoVistaFilter(
  searchParams: URLSearchParams,
  vista: InstanciaEstadoVista,
): URLSearchParams {
  const params = new URLSearchParams(searchParams);
  params.delete('estado');
  params.set('estado', vista);
  params.set('page', '1');
  return params;
}
